var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProHelpStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.313 13.813-1.25 3.124v1.875l3.125-1.562 1.25.313 2.812 1.25-.625-4.063 2.813-2.5-.313-.625-3.438-.313-.937-1.25-1.563 2.188-1.875 1.563Z",
    fill: "#FFF2DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.5 7.25 1.931 3.912 4.319.632-3.125 3.043.738 4.3-3.863-2.03-3.862 2.03.737-4.3-3.125-3.043 4.319-.632L7.5 7.25Z",
    stroke: "url(#a)",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.125 3.125-.5 1.25v.75l1.25-.625.5.125 1.125.5-.25-1.625 1.125-1-.125-.25-1.375-.125-.375-.5-.625.875-.75.625Z",
    fill: "#FFF2DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15 .5.773 1.565 1.727.252-1.25 1.218.295 1.72L15 4.442l-1.545.813.295-1.72-1.25-1.218 1.727-.252L15 .5Z",
    stroke: "url(#b)",
    strokeWidth: 0.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 7.5,
    y1: 7.25,
    x2: 7.5,
    y2: 19.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 15,
    y1: 0.5,
    x2: 15,
    y2: 5.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProHelpStar);
export default __webpack_public_path__ + "static/media/pro-help-star.0c0572d78b572b35d77389d294e584d56a6e55cc4953de59e7f21c11ce7ca649.svg";
export { ForwardRef as ReactComponent };